export enum WorksWellWithEnum {
  NO_PRODUCTS = -1,
  ONE_PRODUCT_DESKTOP = 0,
  TWO_PRODUCT_DESKTOP = 1,
  THREEPLUS_PRODUCT_DESKTOP = 2,
  MOBILE = 3,
}
